<template>
  <div v-if="notValidatedActions.length>0">
    <hr>
    Не утрвержденные действия
    <div class="d-flex justify-content-between mb10" v-for="(action, ind) in notValidatedActions">
      <div class="left">
        <a class="cursor titleHover"
           :class="{highlight:typeof action.id === 'number' && action.id === selectedAction.id, 'bg-danger': action.status === 0, 'bg-danger': action.status !== 0}"
           @click="actionClick(action,ind)">
          {{ getSecondRouteName(action.secondShortRoute) + " - " + action.id }} -
          {{  " код " + action.request_data.request.code }}
          {{ action.request_data.request.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {funcs} from "@/_helpers/_sumple_funcs";
export default {
  name: "notValidatedActions",
  props: {
    notValidatedActions: [],
    selectedAction: {
      id: null,
    }
  },
  methods: {
    actionClick(action, ind) {
      this.$emit('actionClick', {action: action, index: ind});
    },
    getSecondRouteName(name){
      return funcs.translateRoutes(name);
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>